import { defineComponentStyle } from "@/components/ui"

export const hStackStyle = defineComponentStyle({
  base: {
    alignItems: "center",
    gap: "md",
  },
})

export type HStackStyle = typeof hStackStyle
